import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import React, {
  forwardRef,
  Fragment,
  useImperativeHandle,
  useState,
} from 'react';

interface DrawerProps extends React.PropsWithChildren {}

export interface DrawerRef {
  open: () => void;
  close: () => void;
}

export const Drawer = forwardRef<DrawerRef, DrawerProps>((props, ref) => {
  const [visible, setVisible] = useState(false);

  const handleSidebarOpen = () => {
    setVisible(true);
  };

  const handleSidebarClose = () => {
    setVisible(false);

    // hapus ?test-run-detail-id dari URL
    const url = new URL(window.location.href);
    url.searchParams.delete('test-run-detail-id');
    window.history.pushState({}, '', url.toString());
  };

  useImperativeHandle(ref, () => ({
    open: handleSidebarOpen,
    close: handleSidebarClose,
  }));

  return (
    <Transition appear show={visible} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        static // Tidak boleh terjadi close otomatis ketika klik di luar dialog
        onClose={() => {}} // Disable automatic close behavior
      >
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="fixed inset-y-0 right-0 flex pl-10">
              <TransitionChild
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <DialogPanel className="w-[120vh]">
                  <div className="flex flex-col h-full bg-white shadow-xl">
                    <div className="flex-1 py-6 overflow-y-auto">
                      <div className="flex items-start justify-end px-4">
                        <button
                          type="button"
                          className="text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          onClick={handleSidebarClose}
                        >
                          <span className="sr-only">Close panel</span>
                          <svg
                            className="w-6 h-6"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>

                      <div className="mt-6">{props.children}</div>
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
});
